export default "/_next/static/fonts/tt_norms_pro_bold-2e987109b451437435a409ee67555849.woff";